<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="客户号">
          <el-input
            v-model="query.tradeUserAccount"
            placeholder="请输入客户号"
          />
        </el-form-item>
        <el-form-item label="购销计划">
          <el-input
            v-model="query.goodsCode"
            placeholder="请输入购销计划"
          />
        </el-form-item>
        <el-form-item label="订变">
          <el-select
            v-model="query.entrustTs"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.entrustTs"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="购销">
          <el-select
            v-model="query.entrustBs"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.entrustBs"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="委托日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="截止日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="entrustNo"
        label="委托编号"
      />
      <af-table-column
        prop="tradingDate"
        label="委托日期"
      />
      <af-table-column
        prop="entrustTimeStr"
        label="委托时间"
      />
      <af-table-column
        prop="entrustPriceStr"
        label="委托价格"
      />
      <af-table-column
        prop="entrustAmount"
        label="委托数量"
      />
      <af-table-column
        prop="entrustStatusStr"
        label="委托状态"
      />
      <af-table-column
        prop="entrustBsStr"
        label="购/销"
      />
      <af-table-column
        prop="entrustTsStr"
        label="订/变"
      />
      <af-table-column
        prop="entrustWayStr"
        label="下单类型"
      />
      <af-table-column
        prop="businessAmount"
        label="成交数量"
      />
      <af-table-column
        prop="surplusFrozenBailStr"
        label="订单担保履约资金"
      />
      <af-table-column
        prop="tradeCompanyCode"
        label="贸易公司"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'

function Query () {
  this.marketId = '000' // 组织编号
  this.tradeUserAccount = '' // 客户号
  this.goodsCode = '' // 购销计划
  this.entrustTs = '' // 订变
  this.entrustBs = '' // 购销
  this.date = [] // 委托日期
}
export default {
  name: 'HistoricalDelegationInquiry',
  data () {
    return {
      query: new Query(),
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      marketId: ''
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.tradingDateBegin = this.query.date.length ? dayJs(this.query.date[0]).format('YYYY-MM-DD') : ''
      param.tradingDateEnd = this.query.date.length ? dayJs(this.query.date[1]).format('YYYY-MM-DD') : ''
      let res = await api.spotPurchaseSaleInquiry.HistoricalDelegatedInquiry(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 导出
    toDownload () {
      let param = {
        marketId: this.marketId,
        execlType: '10',
        excelHead: [
          // {
          //   fieldLabel: '组织',
          //   excelColumn: 'marketName'
          // },
          {
            fieldLabel: '客户',
            excelColumn: 'userAccount'
          },
          {
            fieldLabel: '客户号',
            excelColumn: 'tradeUserAccount'
          },
          {
            fieldLabel: '客户名称',
            excelColumn: 'userName'
          },
          {
            fieldLabel: '购销计划',
            excelColumn: 'goodsCode'
          },
          {
            fieldLabel: '委托编号',
            excelColumn: 'entrustNo'
          },
          {
            fieldLabel: '委托日期',
            excelColumn: 'tradingDate'
          },
          {
            fieldLabel: '委托时间',
            excelColumn: 'entrustTimeStr'
          },
          {
            fieldLabel: '委托价格',
            excelColumn: 'entrustPriceStr'
          },
          {
            fieldLabel: '委托数量',
            excelColumn: 'entrustAmount'
          },
          {
            fieldLabel: '委托状态',
            excelColumn: 'entrustStatusStr'
          },
          {
            fieldLabel: '购/销',
            excelColumn: 'entrustBsStr'
          },
          {
            fieldLabel: '订/变',
            excelColumn: 'entrustTsStr'
          },
          {
            fieldLabel: '下单类型',
            excelColumn: 'entrustWayStr'
          },
          {
            fieldLabel: '成交数量',
            excelColumn: 'businessAmount'
          },
          {
            fieldLabel: '订单担保履约资金',
            excelColumn: 'surplusFrozenBailStr'
          },
          {
            fieldLabel: '贸易公司',
            excelColumn: 'tradeCompanyCode'
          }
        ]
      }
      this.$utils.getExcelFile(this, api.download, param)
    },
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
<style lang="scss" scoped>
  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child td:nth-child(6) div,
  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child td:nth-child(7) div {
    display: none;
  }

</style>
